import { render, staticRenderFns } from "./NotificationFailed.vue?vue&type=template&id=5d50fcdc&scoped=true&"
import script from "./NotificationFailed.vue?vue&type=script&lang=js&"
export * from "./NotificationFailed.vue?vue&type=script&lang=js&"
import style0 from "./NotificationFailed.vue?vue&type=style&index=0&id=5d50fcdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d50fcdc",
  null
  
)

export default component.exports